import Box from '@aura/components/box'
import Paper from '@aura/components/paper'
import { withStyles } from '@aura/components/styles'
import Typography from '@aura/components/typography'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import styles from './styles'


const RegistrationContainer = ({
    children,
    classes,
    title,
    verbiage
}) => {

    const { t: translate } = useTranslation()

    return (<Paper spacing={2} className={classes.registrationContainer}>
        <Typography className={classes.title}>{title}</Typography>
        <Typography className={classes.verbiage}>{verbiage}</Typography>
        <Paper className={classes.childrenContainer}>{children}</Paper>
        <Box component="p" className={classes.helpText}>{translate('errorPage.helpText')}</Box>
    </Paper>)
}

RegistrationContainer.propTypes = {
    children: PropTypes.object,
    classes: PropTypes.object,
    title: PropTypes.string,
    verbiage: PropTypes.string
}

export default withStyles(RegistrationContainer, styles)
